import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { PetitionQRCodeDownload } from 'src/app/pages/starterDashboardV2/shared/components';
import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { FlyerDownloadLoaderReskin } from './components/FlyerDownloadLoader/index_new';
import { useShareYourPetitionOffline } from './hooks/useShareYourPetitionOffline';

export function ShareYourPetitionOfflineReskin() {
	const { data, actions } = useShareYourPetitionOffline();

	return (
		<section
			id="share_qrcode_module"
			data-qa="share-qrcode-module"
			className="bg-background-base flex scroll-mt-20 flex-col gap-6 px-4 py-8 md:scroll-mt-[4.5rem] md:p-12"
			aria-label="Share petition in person"
		>
			<div className="text-typography-strong flex flex-row items-center gap-1">
				<Text as="h3" className="text-size-heading-small">
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.title" />
				</Text>
				<InfoTooltip aria-describedby="share-petition-offline-title" tabIndex={0}>
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.tooltip_posters" />
				</InfoTooltip>
			</div>
			<div>
				<PetitionQRCodeDownload
					slugOrId={data.slugOrId}
					displaySize={112}
					downloadSize={data.downloadSize}
					displayType={data.displayType}
					downloadType={data.downloadType}
					descriptionText={data.descriptionText}
					downloadLinkText={data.downloadLinkText}
					downloadFilename={data.downloadFilename}
					onDownload={actions.handleDownload}
				/>
			</div>
			<FlyerDownloadLoaderReskin />
		</section>
	);
}
